import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    inject,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { Plan } from '@bytel/bytel-sales';

import { DataCyDirective } from '@base/common/directives/data-cy.directive';
import { PriceComponent } from '@base/trilogy/price/price.component';

import { ConfigurationService } from '@services/configuration.service';
import { MessageService } from '@services/message.service';

import { SimContextModel } from '@models/sim-context.model';

import { ISim, SIM_TYPES } from '@interfaces/sim.interace';

import { ACTION_CLICK } from '@shared/tag/tag.interface';
import { TagService } from '@shared/tag/tag.service';

import { EsimCompatibilityComponent } from './esim-compatibility-modal/esim-compatibility-modal.component';
import { SimIncompatibilityAlertComponent } from './sim-incompatibility-alert/sim-incompatibility-alert.component';

@Component({
    selector: 'checkout-sim',
    standalone: true,
    imports: [CommonModule, RouterModule, DataCyDirective, PriceComponent, SimIncompatibilityAlertComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './sim.component.html',
    styleUrls: ['./sim.component.scss'],
})
export class SimComponent implements OnChanges {
    @Input() simContext: SimContextModel;
    @Input() hasPhone: boolean;
    @Input() selectedSim: ISim;
    @Input() isRenew: boolean;
    @Input() isLoading: boolean;
    @Input() currentPlan?: Plan;
    @Output() simChoice = new EventEmitter<ISim>();

    public SIM_TYPES = SIM_TYPES;
    public choosenSim: ISim;
    public sims: ISim[];
    public isSummerEditionPlan: boolean = false;
    public incompatibleSimType: string | null = null;

    public readonly keepSim: ISim = {
        gencode: 'keepMySim',
        isCompatibleTerminal: true,
        isPrefered: true,
        price: 0,
        priceType: 0,
        type: SIM_TYPES.SIM,
    };

    protected messageService: MessageService = inject(MessageService);
    protected tagService: TagService = inject(TagService);
    private configService: ConfigurationService = inject(ConfigurationService);

    ngOnChanges(): void {
        this.refresh();
    }

    public onChoice(event: PointerEvent, sim: ISim | undefined): void {
        this.choosenSim = sim;

        this.incompatibleSimType = null;

        if (sim) {
            if (this.isRenew) {
                this.sendTag(
                    sim.type === 'sim' ? 'Nouvelle_Carte_SIM' : 'Nouvelle_eSIM',
                    ACTION_CLICK.SELECTION,
                    'Selection_SIM',
                );
            } else {
                this.sendTag(sim.type === 'sim' ? 'Carte_SIM' : 'eSIM', ACTION_CLICK.SELECTION, 'Selection_SIM');
            }
        }

        if (sim && this.hasPhone && !sim.isCompatibleTerminal) {
            this.incompatibleSimType = sim.type;
        }
        this.simChoice.emit(sim);
    }

    public showCompatibilityModal(): void {
        this.sendTag('Voir_telephones_compatibles', ACTION_CLICK.CLICK, 'Bloc_SIM');
        this.messageService.openModal(EsimCompatibilityComponent);
    }

    private refresh(): void {
        if (this.simContext) {
            this.sims = this.simContext.sims;
        }
        this.isSummerEditionPlan =
            this.currentPlan.gencode === this.configService.getData()?.global?.specialOffers?.summerEdition;
    }

    private sendTag(event: string, action: ACTION_CLICK, categorie: string): void {
        this.tagService.send({
            nomClic: event,
            categorieClic: categorie,
            actionClic: action,
        });
    }
}
